export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/ai-instructions": [3],
		"/bitcoin-news": [4],
		"/daily-planner": [5],
		"/edit-birth-data": [6],
		"/enter-birth-data": [7],
		"/learn-app": [8],
		"/learn-astrology": [9],
		"/learn-pro": [10],
		"/mercury-retro": [11],
		"/moon-voc": [12],
		"/personality": [13],
		"/quarterly-planner": [14],
		"/relationship": [15],
		"/settings": [16],
		"/travel-planner": [17],
		"/weekly-planner": [18],
		"/world-news": [19]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';